<template>
  <div>
    <div class="action-overlay" v-show="dialogDisplay">
      <div class="container">
        <p>話題を作成</p>
        <div class="item">
          <input type="text" placeholder="話題名" v-model="hashtagName"><span class="focusborder"></span>
        </div>
        <div class="action">
          <button class="cancel" @click="toggleDialog">キャンセル</button>
          <button class="confirm" @click="create">作成</button>
        </div>
      </div>
    </div>
    <a href="" @click.prevent="toggleDialog"><span>話題をつくる +</span></a>
  </div>
</template>
<script setup>
import axios from 'axios'
import Global from '../js/constant.js'
import ErrorHandler from '../js/error-handler.js'
import { computed, defineProps, ref } from 'vue'
import { useStore } from 'vuex'
import { useToast } from 'vue-toast-notification'

const $store = useStore()
const $toast = useToast()

// props
const props = defineProps({
  circleId :{
    type:Number,
    required:false
  },
})

// state
const hashtagName = ref(null)
const dialogDisplay = ref(false)
const saveButtonDisplay = ref(false)

// mapstate
const circleMode = computed(() => $store.state.circle.circleMode)

// mapmutation
const setSectionHashtagsReloadFlg = (val) => $store.commit('setSectionHashtagsReloadFlg',val)
// const setClientErrors = (val) => $store.commit('setClientErrors',val)

const toggleDialog = () => {
  dialogDisplay.value = !dialogDisplay.value
}
const create = async () => {
  if (!hashtagName.value) return
  mstTopicsCreate()
}
const mstTopicsCreate = async () => {
  let params = {
      name : hashtagName.value,
      official : false,
  }
  if (props.circleId > 0) params['circle_id'] = props.circleId
  if (props.circleId > 0) params['official_circle'] = circleMode.value === Global.circle_mode.public
  
  await axios.post(Global.url.api_mst_topics_create, params)
  .then(res => {
    if (res.data.status === Global.api_status.validation_error) {
      $toast.error(ErrorHandler.errorsToArray(res.data.errors))
      return
    }
    if (res.data.status === Global.api_status.success) {
      setSectionHashtagsReloadFlg(true)
      toggleDialog()
      hashtagName.value = null
      saveButtonDisplay.value = false
      return
    }
  }).catch(error => {
    console.dir(error)
    $toast.error('client error')
  })
}
</script>
<!-- <script>
import {mapState, mapMutations} from 'vuex'
import ErrorHandler from '../../js/error-handler'
import mst_topics from '../../js/api/mst-topics'

export default {
  props : {
    circleId :{
      type:Number,
      required:false
    },
  },
  data () {
    return {
      hashtagName:null,
      dialogDisplay:false,
      saveButtonDisplay:false
    }
  },
  computed:{
    ...mapState([
      'circleMode',
    ]),
  },
  mounted : function () {

  },
  methods:{
    ...mapMutations([
      'setSectionHashtagsReloadFlg',
      'setClientErrors'
    ]),
    toggleDialog : function () {
      this.dialogDisplay = !this.dialogDisplay
    },
     create : async function () {
      if (!this.hashtagName) return
      this.mstTopicsCreate()

    },
    mstTopicsCreate : function () {
      let ret = mst_topics.create(this.hashtagName, false, this.circleId, this.circleMode===this.Global.circle_mode.public? true : false)
      ret.then(res => {
        if (res.data.status === this.Global.api_status.validation_error) {
          this.$toasted.error(ErrorHandler.errorsToArray(res.data.errors))
          return
        }
        if (res.data.status === this.Global.api_status.success) {
          this.setSectionHashtagsReloadFlg(true)
          this.toggleDialog()
          this.hashtagName=null
          this.saveButtonDisplay=false
          return
        }
        this.$toasted.error("error occured!")
        this.setClientErrors({func:"common/new-hashtag.vue::create", params: {}, errorMessage:JSON.stringify(res.data)})
      }).catch(error=>{
        this.$toasted.error('client error')
        this.setClientErrors({func:"common/new-hashtag.vue::create", params: {}, errorMessage:error})
      })
    },
  }
}
</script> -->